import { render } from "./CommonFooter.vue?vue&type=template&id=da6643b2&scoped=true"
const script = {}

import "./CommonFooter.vue?vue&type=style&index=0&id=da6643b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6643b2"]])

export default __exports__